var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"icon":"","small":""},on:{"click":_vm.doCopy}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"x-small":""},domProps:{"innerHTML":_vm._s(_vm.icon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }